import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useTypesOfBirthMothersAge from './hooks/useTypesOfBirthMothersAge';

export const TypesOfBirthMothersAge = () => {
    const { chartConfig } = useTypesOfBirthMothersAge();

    return (
        <ChartContainer
            title={"Tipos de Parto por Idade da Mãe"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={350}
        />
    );
};
